/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography } from '@mui/material';
import { ModalButton } from './ModalButton';
import { GeneralModal } from './GeneralModal';

export const ConfirmationModal = (props) => {
  return (
    <GeneralModal open={props.open} onClose={props.onClose}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {props.title}
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2, mb: 4 }}>
        {props.desc}
      </Typography>
      <ModalButton
        primaryClickHandler={props.primaryClickHandler}
        secondaryClickHandler={props.secondaryClickHandler}
        primaryBtnName={props.primaryBtnName}
        secondaryBtnName={props.secondaryBtnName}
        primaryStyle={props.primaryStyle}
        secondaryStyle={props.secondaryStyle}
      />
    </GeneralModal>
  );
};
